import {TypeInt, TypeFloat, TypeChar, TypeBool} from './../Parser/TypeDefinition'
import Memory from './Memory'
import {ExecutionError, NullVariableError, IndexOutOfRangeError, NullArrayVariableError, IncompatibleTypesError, BooleanReadError, AritmeticError, UndefinedError} from './ErrorTypes'
import Big from 'big.js'

function VirtualMachine () {
    this.inspectionListener = null
    this.contextStartListener = null
    this.contextEndListener = null
    this.evaluateInspections = false
}

VirtualMachine.prototype = {
    OK_SIGNAL: 5000,
    READ_SIGNAL: 1000,
    WRITE_SIGNAL: 1001,
    WAIT_TIME_SIGNAL: 1002,
    EXTERNAL_FUNC_SIGNAL: 1003,
    ERROR_SIGNAL: 1004,
    END_SIGNAL: 1005,
    CLEAR_SIGNAL: 1006,
    WAIT_KEY_SIGNAL: 1007,
    EXEC_TO_NEXT_INS: 2001,
    EXEC_TO_NEXT_LINE: 2002,
    EXEC_TO_NEXT_IO: 2003,
    setProgram (program) {
        this.program = program
        this.instructionCount = program.instructionCount()
        this.writeData = null
        this.waitValue = null
        this.incrementPc = true
        this.currentLine = this.getFirstLine()
        this.lastError = null
        this.readIns = null

        this.inspectionsValues = {}
        this.setEvaluateInspections()

        // Virtual Machine Registers And Memory
        this.pc = 0
        this.memory = new Memory()
    },
    setEvaluateInspections () {
        this.evaluateInspections = this.program &&
                                   this.program.hasInspections() &&
                                   (this.inspectionListener !== null || this.contextStartListener !== null || this.contextEndListener !== null)
    },
    setInspectionListener (listener) {
        this.inspectionListener = listener
        this.setEvaluateInspections()
    },
    setContextStartListener (listener) {
        this.contextStartListener = listener
        this.setEvaluateInspections()
    },
    setContextEndListener (listener) {
        this.contextEndListener = listener
        this.setEvaluateInspections()
    },
    executeStep () {
        return this.execute(this.EXEC_TO_NEXT_INS)
    },
    executeLine () {
        return this.execute(this.EXEC_TO_NEXT_LINE)
    },
    executeAll () {
        return this.execute(this.EXEC_TO_NEXT_IO)
    },
    getCurrentLine () {
        return this.currentLine
    },
    getFirstLine () {
        if (this.instructionCount > 0) {
            let ins = this.program.get(0)
            if (ins && ins.debug && ins.debug.fromLine) {
                return ins.debug.fromLine
            }
        }
        return 0
    },
    getWriteData () {
        return this.writeData
    },
    getWaitValue () {
        return this.waitValue
    },
    getLastError () {
        return this.lastError
    },
    getProgram () {
        return this.program
    },
    _dumpAll () {
        console.log('mem')
        this.memory._dump()
        console.log('program')
        this.program._dump()
        console.log('pc ' + this.pc)
    },
    execute (to) {
        let status
        let ins
        let prevPC

        if (this.pc <= this.instructionCount) {
            if (to === this.EXEC_TO_NEXT_LINE) {
                let nextLine = this.program.get(this.pc).debug.fromLine
                prevPC = this.pc
                while (this.currentLine === nextLine) {
                    prevPC = this.pc
                    ins = this.program.get(this.pc)
                    status = this.executeInstruction(ins)
                    if (this.incrementPc) {
                        this.pc++
                    }
                    if (status === this.OK_SIGNAL) {
                        if (this.pc <= this.instructionCount) {
                            nextLine = this.program.get(this.pc).debug.fromLine
                        } else {
                            break
                        }
                    } else {
                        break
                    }
                }
                if (this.evaluateInspections && this.currentLine !== nextLine) {
                    this.executeInspections(prevPC)
                }
                this.currentLine = nextLine
            } else if (to === this.EXEC_TO_NEXT_IO) {
                if (this.pc <= this.instructionCount) {
                    status = this.OK_SIGNAL
                    while (status === this.OK_SIGNAL) {
                        ins = this.program.get(this.pc)
                        status = this.executeInstruction(ins)
                        if (this.incrementPc) {
                            this.pc++
                        }
                    }
                }
            } else if (to === this.EXEC_TO_NEXT_INS) {
                let nextLine = this.program.get(this.pc).debug.fromLine
                prevPC = this.pc
                if (this.pc <= this.instructionCount) {
                    ins = this.program.get(this.pc)
                    status = this.executeInstruction(ins)
                }
                if (this.incrementPc) {
                    this.pc++
                }
                if (this.pc <= this.instructionCount) {
                    nextLine = this.program.get(this.pc).debug.fromLine
                }
                if (this.evaluateInspections && this.currentLine !== nextLine) {
                    this.executeInspections(prevPC)
                }
                this.currentLine = nextLine
            }
        }
        if (this.pc > this.instructionCount) {
            status = this.END_SIGNAL
        }

        return status
    },
    executeInspections (prevPC) {
        if (this.program.get(prevPC).instruction === this.program.CODE.RETURN) {
            return
        }
        let inspections = this.program.getInspections(prevPC)
        if (inspections.length > 0) {
            let oldPc = this.pc
            let oldProgram = this.program
            let oldIncrementPc = this.incrementPc
            let oldInstructionCount = this.instructionCount
            let oldLastError = this.lastError
            let stackCount = this.memory.stack.length
            let ins
            let status
            let valueType
            let lineInspections = {}
            for (let i in inspections) {
                this.program = inspections[i].program
                this.instructionCount = inspections[i].program.instructionCount()
                this.lastError = null
                this.pc = 0
                this.incrementPc = true
                while (this.pc <= this.instructionCount) {
                    ins = this.program.get(this.pc)
                    status = this.executeInstruction(ins)
                    if (this.incrementPc) {
                        this.pc++
                    }
                    if (status !== this.OK_SIGNAL) {
                        break
                    }
                }
                if (status === this.OK_SIGNAL) {
                    valueType = this.memory.pop()
                } else {
                    if (this.lastError !== null) {
                        if (this.lastError.isNullVariable()) {
                            valueType = null
                        } else {
                            valueType = undefined
                        }
                    }
                    if (this.memory.stack.length > stackCount) {
                        let remove = this.memory.stack.length - stackCount
                        for (let i = 0; i < remove; i++) {
                            this.memory.pop()
                        }
                    } else if (this.memory.stack.length < stackCount) {
                        console.log('********************** se ha perdido info ********************** ')
                    }
                }
                if (lineInspections[inspections[i].context] === undefined) {
                    lineInspections[inspections[i].context] = []
                }
                lineInspections[inspections[i].context].push({
                    id: inspections[i].id,
                    value: valueType
                })

                if (stackCount !== this.memory.stack.length) {
                    console.log('**********************  Error en la ejecución. Cierre el inspector.--> ' + this.memory.stack.length)
                    break
                }
            }
            for (let context in lineInspections) {
                this.inspectionListener(this.currentLine + 1, context, lineInspections[context])
            }
            this.pc = oldPc
            this.program = oldProgram
            this.incrementPc = oldIncrementPc
            this.instructionCount = oldInstructionCount
            this.lastError = oldLastError
        }
    },
    executeInstruction (ins) {
        let status = this.OK_SIGNAL
        let CODE = this.program.CODE
        this.incrementPc = true
        if (this.lastError !== null) {
            return this.ERROR_SIGNAL
        }

        switch (ins.instruction) {
        // Bloques
        case CODE.START:
            this.start(ins); break
        case CODE.END:
            status = this.END_SIGNAL
            if (this.contextEndListener) {
                this.contextEndListener(ins.context)
            }
            break

        // Memoria
        case CODE.PUSH:
            this.push(ins); break
        case CODE.POP:
            this.pop(ins); break
        case CODE.LDCONS:
            this.ldcons(ins); break
        case CODE.ALLOCA:
            this.alloca(ins); break
        case CODE.FREEA:
            this.freea(ins); break
        case CODE.STORE:
            this.store(ins); break
        case CODE.STOREI:
            this.storei(ins); break
        case CODE.STOREA:
            this.storea(ins); break
        case CODE.LOAD:
            this.load(ins); break
        case CODE.LOADA:
            this.loada(ins); break
        case CODE.LOADI:
            this.loadi(ins); break
        case CODE.LDREF:
            this.ldref(ins); break
        case CODE.LDREFA:
            this.ldrefa(ins); break
        case CODE.ARRCPY:
            this.arrcpy(ins); break

        // Operaciones aritméticas
        case CODE.SUM:
            this.sum(ins); break
        case CODE.SUB:
            this.sub(ins); break
        case CODE.MUL:
            this.mul(ins); break
        case CODE.DIV:
            this.div(ins); break
        case CODE.POW:
            this.pow(ins); break
        case CODE.MOD:
            this.mod(ins); break
        case CODE.ABS:
            this.abs(ins); break
        case CODE.SQRT:
            this.sqrt(ins); break

        // Operadores logicos
        case CODE.OR:
            this.or(ins); break
        case CODE.AND:
            this.and(ins); break
        case CODE.NOT:
            this.not(ins); break
        case CODE.EQ:
            this.eq(ins); break
        case CODE.NEQ:
            this.neq(ins); break
        case CODE.LT:
            this.lt(ins); break
        case CODE.LTE:
            this.lte(ins); break
        case CODE.GT:
            this.gt(ins); break
        case CODE.GTE:
            this.gte(ins); break
        case CODE.CCMP:
            this.ccmp(ins); break

        // Control de flujo
        case CODE.JUMP:
            this.pc = ins.op1
            this.incrementPc = false
            break
        case CODE.BRANCH:
            let val = this.memory.pop()
            if (val.value === false) {
                this.pc = ins.op1
                this.incrementPc = false
            } else if (val.value !== true) {
                this.lastError = new IncompatibleTypesError('Incompatible Type on Branch', ins)
                status = this.ERROR_SIGNAL
            }
            break
        case CODE.CALL:
            this.memory.push(TypeInt(), this.pc)
            this.pc = ins.op1
            this.incrementPc = false
            break
        case CODE.RETURN:
            this.pc = this.memory.pop().value
            this.memory.decrBlock()

            if (this.contextEndListener) {
                this.contextEndListener(ins.context)
            }
            break

        // Entrada/Salida
        case CODE.READ:
            this.readIns = ins
            status = this.READ_SIGNAL
            break
        case CODE.WRITE:
            if (this.write(ins)) {
                status = this.WRITE_SIGNAL
            } else {
                status = this.ERROR_SIGNAL
            }
            break
        case CODE.CSCR:
            status = this.CLEAR_SIGNAL
            break
        case CODE.WTIME:
            if (this.waitTime(ins)) {
                status = this.WAIT_TIME_SIGNAL
            } else {
                status = this.ERROR_SIGNAL
            }
            break
        case CODE.WKEY:
            status = this.WAIT_KEY_SIGNAL
            break

        default:
            this.lastError = new ExecutionError('No se reconoce la instrucción.', ins)
            status = this.ERROR_SIGNAL
        }

        if (this.lastError !== null) {
            status = this.ERROR_SIGNAL
        }

        return status
    },
    cast (A, B, ins) {
        let resultType = A.type
        if (!A.type.eq(B.type)) {
            if ((A.type.isInt() && B.type.isFloat()) ||
                (A.type.isFloat() && B.type.isInt())) {
                // Cast a Float
                resultType = TypeFloat()
            } else {
                this.lastError = new IncompatibleTypesError('Incompatible type on cast', ins)
            }
        }
        return resultType
    },
    start (ins) {
        this.memory.incBlock()
        if (this.contextStartListener) {
            this.contextStartListener(ins.context)
        }
    },
    push (ins) {
        for (let i = 0; i < ins.op2; i++) {
            this.memory.push(ins.op1, null, ins.debug.ident)
        }
    },
    pop (ins) {
        for (let i = 0; i < ins.op2; i++) {
            this.memory.pop()
        }
    },
    ldcons (ins) {
        this.memory.push(ins.op1, ins.op2)
    },
    alloca (ins) {
        this.memory.alloca(ins.op1, ins.op2)
    },
    freea (ins) {
        let addr = this.memory.peek().value
        this.memory.freea(addr, ins.op1)
    },
    store (ins) {
        let newValue = this.memory.pop()
        this.memory.write(ins.op2, ins.op1, newValue.value)
    },
    storei (ins) {
        let newValue = this.memory.pop()
        let address = this.memory.read(ins.op2)
        this.memory.writeAbs(address.value, newValue.type, newValue.value)
    },
    storea (ins) {
        let newValue = this.memory.pop()
        let index = parseInt(this.memory.pop().value.toString())
        let addr = this.memory.read(ins.op2).value
        let arraySize = this.memory.read(addr).value

        if (index < 0 || index >= arraySize) {
            this.lastError = new IndexOutOfRangeError('', index, ins)
            return
        }

        this.memory.write(addr + index + 1, newValue.type, newValue.value)
    },
    load (ins) {
        let obj = this.memory.read(ins.op2, ins.op1)
        if (obj === undefined) {
            this.lastError = new UndefinedError('', ins)
            return
        }

        if (obj.value === null) {
            this.lastError = new NullVariableError('', ins)
            return
        }
        this.memory.push(obj.type, obj.value)
    },
    loadi (ins) {
        let absoluteDir = this.memory.read(ins.op2)
        let data = this.memory.readAbs(absoluteDir.value)
        if (data === undefined) {
            this.lastError = new UndefinedError('', ins)
            return
        }

        if (data.value === null) {
            this.lastError = new NullVariableError('', ins)
            return
        }
        this.memory.push(data.type, data.value)
    },
    loada (ins) {
        let index = parseInt(this.memory.pop().value.toString())
        let arrayAddress = this.memory.read(ins.op2)

        if (arrayAddress === undefined) {
            this.lastError = new UndefinedError('', ins)
            return
        }
        arrayAddress = arrayAddress.value

        let arraySize = this.memory.read(arrayAddress)
        if (arraySize === undefined) {
            this.lastError = new UndefinedError('', ins)
            return
        }
        arraySize = arraySize.value
        if (index < 0 || index >= arraySize) {
            this.lastError = new IndexOutOfRangeError('', index, ins)
            return
        }
        let data = this.memory.read(arrayAddress + index + 1)
        if (data === undefined) {
            this.lastError = new UndefinedError('', ins)
            return
        }
        if (data.value === null) {
            this.lastError = new NullArrayVariableError('', index, ins)
            return
        }
        this.memory.push(data.type, data.value)
    },
    ldref (ins) {
        this.memory.ldref(ins.op2)
    },
    ldrefa (ins) {
        let index = parseInt(this.memory.pop().value.toString())
        this.memory.ldrefa(ins.op2, index)
    },
    arrcpy (ins) {
        this.memory.arrcpy(ins.op1, ins.op2)
    },

    sum (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        let value = B.value.plus(A.value)
        this.memory.push(this.cast(A, B, ins), value)
    },
    sub (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        let value = B.value.sub(A.value)
        this.memory.push(this.cast(A, B, ins), value)
    },
    mul (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        let value = B.value.mul(A.value)
        this.memory.push(this.cast(A, B, ins), value)
    },
    div (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        let value
        try {
            value = B.value.div(A.value)
            this.memory.push(TypeFloat(), value)
        } catch (e) {
            if (e.message === '[big.js] Division by zero') {
                this.lastError = new AritmeticError('División por cero.', ins)
            } else {
                this.lastError = new ExecutionError('Error en división', ins)
            }
        }
    },
    pow (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        let value = B.value.pow(parseInt(A.value.toString()))
        this.memory.push(this.cast(A, B, ins), value)
    },
    mod (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        let value
        try {
            value = B.value.mod(A.value)
            this.memory.push(this.cast(A, B, ins), value)
        } catch (e) {
            if (e.message === '[big.js] Division by zero') {
                this.lastError = new AritmeticError('División por cero.', ins)
            } else {
                this.lastError = new ExecutionError('Error en división', ins)
            }
        }
    },
    abs (ins) {
        let A = this.memory.pop()
        let value = A.value.abs()
        this.memory.push(A.type, value)
    },
    sqrt (ins) {
        let A = this.memory.pop()
        let value
        try {
            value = A.value.sqrt()
            this.memory.push(TypeFloat(), value)
        } catch (e) {
            if (e.message === '[big.js] No square root') {
                this.lastError = new AritmeticError('Raíz cuadrada de número negativo.', ins)
            } else {
                this.lastError = new ExecutionError('Error en raíz cuadrada.', ins)
            }
        }
    },
    or (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        this.memory.push(TypeBool(), B.value || A.value)
    },
    and (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        this.memory.push(TypeBool(), B.value && A.value)
    },
    not (ins) {
        let A = this.memory.pop()
        this.memory.push(A.type, !A.value)
    },
    eq (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        let value = null
        if ((A.type.isNumeric() && B.type.isNumeric()) ||
            (A.type.isChar() && B.type.isChar())) {
            // Es un comparador numérico
            value = B.value.eq(A.value)
        } else if (A.type.eq(B.type)) {
            value = B.value === A.value
        } else {
            this.lastError = new IncompatibleTypesError('Incompatible type on eq', ins)
            return
        }
        this.memory.push(TypeBool(), value)
    },
    neq (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        let value = null
        if ((A.type.isNumeric() && B.type.isNumeric()) ||
            (A.type.isChar() && B.type.isChar())) {
            // Es un comparador numérico
            value = !B.value.eq(A.value)
        } else if (A.type.eq(B.type)) {
            value = B.value !== A.value
        } else {
            this.lastError = new IncompatibleTypesError('Incompatible type on neq', ins)
            return
        }
        this.memory.push(TypeBool(), value)
    },
    lt (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        let value = null
        if ((A.type.isNumeric() && B.type.isNumeric()) ||
            (A.type.isChar() && B.type.isChar())) {
            // Es un comparador numérico
            value = B.value.lt(A.value)
        } else {
            this.lastError = new IncompatibleTypesError('Incompatible type on lt', ins)
            return
        }
        this.memory.push(TypeBool(), value)
    },
    lte (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        let value = null
        if ((A.type.isNumeric() && B.type.isNumeric()) ||
            (A.type.isChar() && B.type.isChar())) {
            // Es un comparador numérico
            value = B.value.lte(A.value)
        } else {
            this.lastError = new IncompatibleTypesError('Incompatible type on lte', ins)
            return
        }
        this.memory.push(TypeBool(), value)
    },
    gt (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        let value = null
        if ((A.type.isNumeric() && B.type.isNumeric()) ||
            (A.type.isChar() && B.type.isChar())) {
            // Es un comparador numérico
            value = B.value.gt(A.value)
        } else {
            this.lastError = new IncompatibleTypesError('Incompatible type on gt', ins)
            return
        }
        this.memory.push(TypeBool(), value)
    },
    gte (ins) {
        let A = this.memory.pop()
        let B = this.memory.pop()
        let value = null
        if ((A.type.isNumeric() && B.type.isNumeric()) ||
            (A.type.isChar() && B.type.isChar())) {
            // Es un comparador numérico
            value = B.value.gte(A.value)
        } else {
            this.lastError = new IncompatibleTypesError('Incompatible type on gte', ins)
            return
        }
        this.memory.push(TypeBool(), value)
    },
    ccmp (ins) {
        let step = this.memory.pop()
        let A = this.memory.pop()
        let B = this.memory.pop()
        if (((A.type.isNumeric() && B.type.isNumeric()) || (A.type.isChar() && B.type.isChar())) && step.type.isNumeric()) {
            if (step.value.gte(0)) {
                this.memory.push(TypeBool(), B.value.gte(A.value))
            } else {
                this.memory.push(TypeBool(), B.value.lte(A.value))
            }
        } else {
            this.lastError = new IncompatibleTypesError('Incompatible type on ccmp', ins)
        }
    },
    write (ins) {
        let item = this.memory.pop()
        let value

        if (item.type.isInt()) {
            value = parseInt(item.value.toString())
        } else if (item.type.isFloat()) {
            value = item.value.toString()
            if (value.indexOf('.') === -1) {
                value += '.0'
            }
        } else if (item.type.isChar()) {
            value = String.fromCharCode(item.value)
        } else if (item.type.isString()) {
            value = '' + item.value
        } else if (item.type.isBool()) {
            if (item.value === true) {
                value = 'Verdadero'
            } else if (item.value === false) {
                value = 'Falso'
            } else {
                this.lastError = new IncompatibleTypesError('Valor logico no reconocido', ins)
                return false
            }
        }
        this.writeData = value
        return true
    },
    waitTime (ins) {
        let item = this.memory.pop()
        let value

        if (item.type.isInt()) {
            value = parseInt(item.value.toString())
        } else {
            this.lastError = new IncompatibleTypesError('Incompatible type on waitTime', ins)
            return false
        }
        this.waitValue = value
        return true
    },
    readCompleted (value) {
        if (this.readIns.op1.isInt()) {
            let hasError = false
            try {
                let sanitized = value.replace(/^\+/g, '')
                let reg = new RegExp('^[-]?\\d+$')
                if (reg.test(sanitized)) {
                    this.memory.push(TypeInt(), new Big(sanitized))
                } else {
                    hasError = true
                }
            } catch (e) {
                hasError = true
            }
            if (hasError) {
                this.lastError = new IncompatibleTypesError('El numero ingresado no es un entero.', this.readIns)
            }
        } else if (this.readIns.op1.isFloat()) {
            try {
                this.memory.push(TypeFloat(), new Big(value))
            } catch (e) {
                this.lastError = new IncompatibleTypesError('El numero ingresado no es un real.', this.readIns)
            }
        } else if (this.readIns.op1.isChar()) {
            try {
                this.memory.push(TypeChar(), new Big(value.charCodeAt(0)))
            } catch (e) {
                this.lastError = new IncompatibleTypesError('La entrada no se pudo reconocer como un caracter.', this.readIns)
            }
        } else if (this.readIns.op1.isBool()) {
            if (value.toLowerCase() === 'verdadero') {
                this.memory.push(TypeBool(), true)
            } else if (value.toLowerCase() === 'falso') {
                this.memory.push(TypeBool(), false)
            } else {
                this.lastError = new BooleanReadError('', this.readIns)
            }
        }
        this.readIns = null
    }
}

export default VirtualMachine



// WEBPACK FOOTER //
// ./src/Core/VirtualMachine/VirtualMachine.js